<template>
  <div>
    <AppToolbar
      :title="organization ? organization.name : ''"
      :prev-route="$security.getUserOrganizations().length > 1 ? { name: 'OrganizationListMap' } : null"
      :toggle-drawer="true"
      @toggleDrawer="$emit('toggleDrawer')"
    >
      <template slot="buttons">
        <v-btn v-if="isShipowner" text icon @click="showOrganizationUpdateDialog = true">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <ToolbarView
          :management-route="{
            name: 'OrganizationShow',
            params: { id: $route.params.id }
          }"
        ></ToolbarView>
      </template>
    </AppToolbar>

    <div>
      <CollapseMapBtn v-if="!isLoading"></CollapseMapBtn>
      <div class="sidenav-body">
        <v-card class="elevation-0">
          <v-card-text class="pa-0">
            <div v-if="organization && $vuetify.breakpoint.mdAndUp" class="pa-3">
              <v-avatar size="50" class="mr-2">
                <img
                  v-if="organization.image"
                  :src="organization.image.contentUrl + '?x-request=html'"
                  :alt="organization.name"
                />
                <img v-else src="../../assets/no-img.svg" />
              </v-avatar>
              <div>
                <span class="headline">{{ organization.name }}</span>
              </div>
            </div>
            <v-divider></v-divider>
            <v-tabs v-model="selectedTab" centered background-color="grey lighten-4">
              <v-tabs-slider color="warning"></v-tabs-slider>
              <v-tab href="#tab-vessels" active>
                {{ $t('message.vessels') }}
              </v-tab>
              <v-tab href="#tab-employees">
                {{ $t('message.employees') }}
              </v-tab>
              <v-tab href="#tab-credit">
                {{ $t('message.credit') }}
              </v-tab>

              <v-tab-item key="tab-vessels" value="tab-vessels">
                <div v-if="vesselsLoading" class="pa-5 text-center">
                  <v-progress-circular indeterminate size="25" color="primary"></v-progress-circular>
                </div>

                <div v-if="!vesselsLoading && vessels && vessels.length > 0">
                  <v-list two-line>
                    <template v-for="(vessel, index) in vessels">
                      <v-divider v-if="index > 0" :key="vessel.name + index.toString()"></v-divider>
                      <v-list-item
                        :key="vessel.name"
                        @click="
                          $router.push({
                            name: 'VesselShowMap',
                            params: { id: $iriToId(vessel['@id']) }
                          })
                        "
                      >
                        <v-list-item-avatar>
                          <img
                            v-if="vessel.image"
                            :src="vessel.image.contentUrl + '?x-request=html'"
                            :alt="vessel.name"
                          />
                          <img v-else src="../../assets/no-img.svg" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{ vessel.name }}</v-list-item-title>
                          <v-list-item-subtitle
                            >{{ vessel.roleInVessels.length }}
                            users
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </div>
              </v-tab-item>
              <v-tab-item key="tab-employees" value="tab-employees">
                <div v-if="!roleInOrganizationsLoading && roleInOrganizations && roleInOrganizations.length > 0">
                  <v-text-field
                    v-model="searchQuery"
                    :placeholder="$t('message.search_by_name')"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    hide-details
                    class="mx-3 mt-3"
                    solo
                  ></v-text-field>
                  <v-list two-line>
                    <template v-for="(roleInOrganization, index) in filteredRoleInOrganizations">
                      <v-divider v-if="index > 0" :key="roleInOrganization.user.name + index.toString()"></v-divider>
                      <v-list-item :key="roleInOrganization.user.name" @click="selectUser(roleInOrganization.user)">
                        <v-list-item-avatar>
                          <v-icon
                            v-if="false === roleInOrganization.user.emailVerified"
                            class="grey lighten-4 grey--text text--lighten-2"
                            >mdi-email-outline</v-icon
                          >
                          <img
                            v-else-if="roleInOrganization.user.image"
                            :src="roleInOrganization.user.image.contentUrl + '?x-request=html'"
                            :alt="roleInOrganization.user.firstName + ' ' + roleInOrganization.user.lastName"
                          />
                          <img
                            v-else
                            src="../../assets/no-img.svg"
                            :alt="roleInOrganization.user.firstName + ' ' + roleInOrganization.user.lastName"
                          />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            >{{ roleInOrganization.user.firstName }}
                            {{ roleInOrganization.user.lastName }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            >{{
                              roleInOrganization.user.emailVerified
                                ? $t('message.' + roleInOrganization.organizationRole.name)
                                : $t('message.accept_invitation_pending')
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </div>

                <div v-if="roleInOrganizationsLoading" class="mt-3 text-center">
                  <v-progress-circular indeterminate size="25" color="primary"></v-progress-circular>
                </div>
              </v-tab-item>
              <v-tab-item key="tab-credit" value="tab-credit">
                <div v-if="hotspotCreditActivitiesLoading" class="pa-5 text-center">
                  <v-progress-circular indeterminate size="25" color="primary"></v-progress-circular>
                </div>
                <div v-else-if="hotspotCreditActivities.length === 0" class="pa-5 text-center">
                  <v-icon color="grey" large class="mb-2">mdi-credit-card-off</v-icon>
                  <p>No credit history</p>
                </div>
                <div v-else>
                  <v-list two-line>
                    <v-text-field
                      v-model="searchNameQuery"
                      :placeholder="$t('message.search_by_name')"
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      hide-details
                      class="mx-3 mb-3"
                      solo
                    ></v-text-field>
                    <v-row>
                      <v-col cols="12" class="pl-6 pr-6">
                        <v-menu
                          v-model="startMenu"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          :close-on-content-click="false"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="startsAt"
                              label="From"
                              readonly
                              outlined
                              clearable
                              dense
                              v-bind="attrs"
                              hide-details
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="startsAt" @input="startMenu = false"></v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" class="pl-6 pr-6 pt-0">
                        <v-menu
                          v-model="endMenu"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          :close-on-content-click="false"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="endsAt"
                              label="To"
                              readonly
                              clearable
                              dense
                              outlined
                              v-bind="attrs"
                              hide-details
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="endsAt" @input="endMenu = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <template v-for="(hotspotCreditActivity, index) in filteredHotspotCreditActivities">
                      <v-divider v-if="index > 0" :key="hotspotCreditActivity.name + index.toString()"></v-divider>
                      <v-list-item :key="hotspotCreditActivity.name">
                        <v-list-item-avatar>
                          <img
                            v-if="hotspotCreditActivity.hotspotUser.user.image"
                            :src="hotspotCreditActivity.hotspotUser.user.image.contentUrl + '?x-request=html'"
                            :alt="hotspotCreditActivity.hotspotUser.user.firstName"
                          />
                          <img v-else src="../../assets/no-img.svg" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            >{{
                              (
                                hotspotCreditActivity.hotspotUser.user.firstName +
                                ' ' +
                                hotspotCreditActivity.hotspotUser.user.lastName
                              ).length > 18
                                ? (
                                    hotspotCreditActivity.hotspotUser.user.firstName +
                                    ' ' +
                                    hotspotCreditActivity.hotspotUser.user.lastName
                                  ).substring(0, 15) + '...'
                                : hotspotCreditActivity.hotspotUser.user.firstName +
                                  ' ' +
                                  hotspotCreditActivity.hotspotUser.user.lastName
                            }}

                            <v-chip
                              class="ml-2"
                              :color="hotspotCreditActivity.amount > 0 ? 'green' : 'red'"
                              small
                              text-color="white"
                            >
                              {{ formatHotspotCreditActivity(hotspotCreditActivity) }}
                            </v-chip>
                          </v-list-item-title>
                          <v-list-item-subtitle
                            >{{ hotspotCreditActivity.createdAt | moment('DD/MM/YYYY') }}
                            by
                            <template v-if="hotspotCreditActivity.createdBy">
                              {{ hotspotCreditActivity.createdBy.firstName }}
                              {{ hotspotCreditActivity.createdBy.lastName }}
                            </template>
                            <template v-else>
                              {{ hotspotCreditActivity.hotspotUser.fullName }}
                            </template>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <div class="text-center mb-6">
                      <div class="mt-3 mb-2">
                        Showing <strong>{{ doneOperations.length }}</strong> of
                        <strong>{{ doneOperationsTotalItems }}</strong> operations
                      </div>
                      <v-btn
                        v-if="doneOperationsTotalItems > doneOperations.length"
                        small
                        depressed
                        color="primary"
                        @click="loadMoreHotspotCreditActivities"
                        >Load more</v-btn
                      >
                    </div>
                  </v-list>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </div>

      <v-btn
        v-if="isShipowner && 'tab-employees' === selectedTab"
        :class="{
          'sidenav-fab': true,
          'sidenav-fab-sm': $vuetify.breakpoint.smAndDown
        }"
        color="warning"
        fixed
        fab
        @click="showUserShowDialog = true"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <UserDialog
        :show="showUserShowDialog"
        :user="selectedUser"
        :organization="organization"
        @close="showUserShowDialog = false"
      ></UserDialog>
      <OrganizationDialog
        :show="showOrganizationUpdateDialog"
        :organization="organization"
        @close="showOrganizationUpdateDialog = false"
      ></OrganizationDialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserDialog from '@/components/user/dialog/Dialog'
import AppToolbar from '@/components/AppToolbar'
import CollapseMapBtn from '@/components/CollapseMapBtn'
import OrganizationDialog from '@/components/organization/dialog/Dialog'
import ToolbarView from '@/components/ToolbarView'
import moment from 'moment'
import fetch from '@/utils/fetch'

export default {
  components: {
    ToolbarView,
    OrganizationDialog,
    CollapseMapBtn,
    UserDialog,
    AppToolbar
  },

  data() {
    return {
      hotspotCreditActivitiesPagination: {
        page: 1,
        itemsPerPage: 25
      },
      showVesselCreateDialog: false,
      showOrganizationUpdateDialog: false,
      showUserShowDialog: false,
      isShipowner: false,
      selectedUser: null,
      selectedTab: null,
      searchQuery: null,
      searchNameQuery: null,
      hotspotCreditActivitiesLoading: false,
      doneOperations: null,
      doneOperationsTotalItems: 0,
      startsAt: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endsAt: moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
      startMenu: false,
      endMenu: false,
      hotspotCreditActivities: []
    }
  },
  computed: {
    ...mapGetters({
      error: 'vessel/list/error',
      vessels: 'vessel/list/items',
      vesselsLoading: 'vessel/list/isLoading',
      view: 'vessel/list/view',
      vesselCreated: 'vessel/create/created',
      organization: 'organization/show/retrieved',
      organizationLoading: 'organization/show/isLoading',
      organizationUpdated: 'organization/update/updated',
      roleInOrganizations: 'roleinorganization/list/items',
      roleInOrganizationsLoading: 'roleinorganization/list/isLoading',
      roleInOrganizationsView: 'roleinorganization/list/view',
      roleInOrganizationsCreated: 'roleinorganization/create/created'
    }),
    isLoading: function() {
      return this.vesselsLoading || this.roleInOrganizationsLoading
    },

    filteredRoleInOrganizations: function() {
      if (!this.roleInOrganizations) {
        return null
      }
      let filteredRoleInOrganizations = this.roleInOrganizations
      if (this.searchQuery) {
        filteredRoleInOrganizations = this.roleInOrganizations.filter(roleInOrganization => {
          const fullName = roleInOrganization.user.firstName + ' ' + roleInOrganization.user.lastName
          return fullName.toLocaleLowerCase().includes(this.searchQuery.toLowerCase())
        })
      }
      return filteredRoleInOrganizations
    },
    filteredHotspotCreditActivities: function() {
      if (!this.hotspotCreditActivities) {
        return null
      }
      let filteredHotspotCreditActivities = this.hotspotCreditActivities
      if (this.searchNameQuery) {
        filteredHotspotCreditActivities = this.hotspotCreditActivities.filter(hotspotCreditActivity => {
          const fullName =
            hotspotCreditActivity.hotspotUser.user.firstName + ' ' + hotspotCreditActivity.hotspotUser.user.lastName
          return fullName.toLocaleLowerCase().includes(this.searchNameQuery.toLowerCase())
        })
      }
      return filteredHotspotCreditActivities
    }
  },

  watch: {
    startsAt() {
      if (this.startsAt || !this.startsAt) {
        this.fetchHotspotCreditActivities()
      }
    },
    endsAt() {
      if (this.endsAt || !this.endsAt) {
        this.fetchHotspotCreditActivities()
      }
    },
    isLoading: function(isLoading) {
      if (isLoading) {
        return
      }

      this.vessels.sort(function(a, b) {
        return a.name > b.name ? 1 : a.name < b.name ? -1 : 0
      })

      this.roleInOrganizations.sort(function(a, b) {
        return a.user.firstName > b.user.firstName ? 1 : a.user.firstName < b.user.firstName ? -1 : 0
      })

      this.$emit('setMapVessel', {})
      this.$emit('setMapOrganization', this.organization)
    },

    roleInOrganizationsCreated: function(roleInOrganizationsCreated) {
      if (!roleInOrganizationsCreated) {
        return
      }
      this.getRoleInOrganizationsPage('/role_in_organizations?organization=' + this.$route.params.id)
    },

    vesselCreated: function(vesselCreated) {
      if (!vesselCreated) {
        return
      }
      this.getVesselsPage('/vessels?organization=' + this.$route.params.id + '&archived=false')
    },

    organizationUpdated: function(organizationUpdated) {
      if (!organizationUpdated) {
        return
      }
      this.getOrganization('/organizations/' + this.$route.params.id)
    },

    showUserShowDialog: function(showUserShowDialog) {
      if (false === showUserShowDialog) {
        this.selectedUser = null
      }
    },
    selectedTab() {
      if (this.selectedTab === 'tab-credit') {
        this.fetchHotspotCreditActivities()
      }
    }
  },

  created() {
    this.$store.commit('mapSetShow', true)
    this.getVesselsPage('/vessels?pagination=false&organization=' + this.$route.params.id + '&archived=false')
    this.getRoleInOrganizationsPage('/role_in_organizations?pagination=false&organization=' + this.$route.params.id)
    this.isShipowner = this.$security.isGranted('/organizations/' + this.$route.params.id, 'ROLE_SHIPOWNER')
    this.getOrganization('/organizations/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      getOrganization: 'organization/show/retrieve',
      getVesselsPage: 'vessel/list/default',
      getRoleInOrganizationsPage: 'roleinorganization/list/default'
    }),
    loadMoreHotspotCreditActivities() {
      this.hotspotCreditActivitiesPagination.itemsPerPage *= 2
      this.fetchHotspotCreditActivities()
    },
    formatHotspotCreditActivity(hotspotCreditActivity) {
      if (hotspotCreditActivity.type === 'time') {
        const totalMinutes = Math.floor(hotspotCreditActivity.amount / 60)
        if (totalMinutes >= 180) {
          const hours = Math.floor(totalMinutes / 60)
          const minutes = totalMinutes % 60
          return minutes > 0 ? `${hours} hours ${minutes} minutes` : `${hours} hours`
        } else {
          return `${totalMinutes} minutes`
        }
      } else if (hotspotCreditActivity.type === 'volume') {
        const megabytes = hotspotCreditActivity.amount / (1024 * 1024)
        if (Math.abs(megabytes) >= 1024) {
          const gigabytes = (megabytes / 1024).toFixed(2)
          return `${gigabytes} GB`
        } else {
          return `${megabytes.toFixed(2)} MB`
        }
      } else {
        return `${hotspotCreditActivity.amount}`
      }
    },
    fetchHotspotCreditActivities() {
      this.hotspotCreditActivitiesLoading = true

      let query =
        '/hotspot_credit_activities?page=' +
        this.hotspotCreditActivitiesPagination.page +
        '&itemsPerPage=' +
        this.hotspotCreditActivitiesPagination.itemsPerPage +
        '&order[createdAt]=desc' +
        '&exists[hotspotUser]=true' +
        '&exists[hotspotUser.user]=true'

      if (this.startsAt) {
        query += '&createdAt[after]=' + this.startsAt
      }

      if (this.endsAt) {
        query +=
          '&createdAt[strictly_before]=' +
          this.$moment(this.endsAt)
            .add(1, 'day')
            .format('YYYY-MM-DD 00:00:00')
      }
      fetch(query, {
        method: 'GET'
      })
        .then(response => response.json())
        .then(data => {
          this.hotspotCreditActivities = data['hydra:member']
          this.doneOperations = data['hydra:member']
          this.doneOperationsView = data['hydra:view']
          this.doneOperationsTotalItems = data['hydra:totalItems']
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.hotspotCreditActivitiesLoading = false
        })
    },
    selectUser: function(user) {
      this.selectedUser = user['@id']
      this.showUserShowDialog = true
    }
  }
}
</script>
